import { DocumentAuditModalData } from '@components/modals/documentAuditModal/DocumentAuditModal';
import { Sizes } from '@utils/sizes';
import { AddPagesToDocumentModalData } from '@components/modals/addPagesToDocumentModal/AddPagesToDocumentModal';
import { AdministrationsModalData } from '@components/modals/administrationsModal/AdministrationsModal';
import { DeleteOcrTrainingModalData } from '@components/modals/deleteOcrTrainingModal/DeleteOcrTrainingModal';
import { SamLineSourceModalData } from '@components/modals/samLineSourceModal/SamLineSourceModal';
import { TemplateSharingManagementModalData } from '@components/modals/templateSharingManagementModal/TemplateSharingManagementModal';
import { RepairDocumentModalData } from '@components/modals/repairDocumentModal/RepairDocumentModal';
import { EditDocumentModalData } from '@components/modals/editDocumentModal/EditDocumentModal';
import { LinkDocumentsModalData } from '@components/modals/linkDocumentsModal/LinkDocumentsModal';
import { ExternalModalName } from '@components/modals/useOpenModalInExternalView';
import { DocumentPreviewModalData } from '@components/modals/previewModal/DocumentPreviewModal';
import { AnnotationModalData } from '@components/modals/annotationModal/AnnotationModal';
import { CopyCodingModalData } from '@components/modals/copyCodingModal/CopyCodingModal';
import { CreditorValidationModalData } from '@components/modals/creditorValidationModal/CreditorValidationModal';
import { UserReplacedModalData } from '@components/modals/userReplacedModal/UserReplacedModal';
import { RefreshLookupModalData } from '@components/modals/refreshLookupModal/RefreshLookupModal';
import { DocumentValidationModalData } from '@components/modals/documentValidationModal/DocumentValidationModal';
import { CodingAccrualsModalData } from '@components/modals/codingAccrualsModal/CodingAccrualsModal';
import { EmailDocumentModalData } from '@components/modals/emailDocumentModal/EmailDocumentModal';
import { TextModalData } from '@components/modals/textModal/TextModal';
import { ConfirmModalData } from '@components/modals/confirmModal/ConfirmModal';
import { ListModalData } from '@components/modals/listModal/ListModal';
import { ReplacementModalData } from '@components/modals/replacementModal/ReplacementModal';
import { WorkflowActionValidationModalData } from '@components/modals/workflowActionValidationModal/WorkflowActionValidationModal';
import { PerformDocumentActionModalData } from '@components/modals/performDocumentActionModal/PerformDocumentActionModal';
import { DynamicAssignModalData } from '@components/modals/dynamicAssignModal/DynamicAssignModal';
import { OcrTrainingLogModalData } from '@components/modals/ocrTrainingLogModal/OcrTrainingLogModal';
import { OcrTrainingSqlModalData } from '@components/modals/ocrTrainingSqlModal/OcrTrainingSqlModal';
import { OcrCodingTrainingModalData } from '@components/modals/ocrCodingTrainingModal/OcrCodingTrainingModal';
import { OcrTrainingFieldModalData } from '@components/modals/ocrTrainingFieldModal/OcrTrainingFieldModal';
import { GridSettingsModalData } from '@components/modals/gridSettingsModal/GridSettingsModal';
import { DocumentAttachmentsModalData } from '@components/modals/documentAttachmentsModal/DocumentAttachmentsModal';
import { CodePreviewModalData } from '@components/modals/codePreviewModal/CodePreviewModal';
import { EmailPreviewModalData } from '@components/modals/emailPreviewModal/EmailPreviewModal';
import { SamBackOfficeStatusHelperModalData } from '@components/modals/samBackOfficeStatusHelperModal/SamBackOfficeStatusHelperModal';

export enum ModalType {
    AddPagesToDocument = 'AddPagesToDocument',
    Administrations = 'Administrations',
    Annotation = 'Annotation',
    CodePreview = 'CodePreview',
    CodingAccruals = 'CodingAccruals',
    Confirm = 'Confirm',
    CopyCoding = 'CopyCoding',
    CreditorValidation = 'CreditorValidation',
    DeleteOcrTraining = 'DeleteOcrTraining',
    DocumentAttachments = 'DocumentAttachments',
    DocumentAudit = 'DocumentAudit',
    DocumentPreview = 'DocumentPreview',
    DocumentValidation = 'DocumentValidation',
    DynamicAssign = 'DynamicAssign',
    EditDocument = 'EditDocument',
    EmailDocument = 'EmailDocument',
    EmailPreview = 'EmailPreview',
    GridSettings = 'GridSettings',
    LinkDocuments = 'LinkDocuments',
    List = 'List',
    OcrCodingTraining = 'OcrCodingTraining',
    OcrTrainingField = 'OcrTrainingField',
    OcrTrainingLog = 'OcrTrainingLog',
    OcrTrainingSql = 'OcrTrainingSql',
    PerformDocumentAction = 'PerformDocumentAction',
    RefreshLookup = 'RefreshLookup',
    RepairDocument = 'RepairDocument',
    Replacement = 'Replacement',
    SamBackOfficeStatusHelper = 'SamBackOfficeStatusHelper',
    SamFeedback = 'SamFeedback',
    SamIntroduction = 'SamIntroduction',
    SamLineSource = 'SamLineSource',
    SamLineSourceMore = 'SamLineSourceMore',
    TemplateSharingManagement = 'TemplateSharingManagement',
    Text = 'Text',
    UserReplaced = 'UserReplaced',
    WorkflowActionValidation = 'WorkflowActionValidation',
}

export interface ModalPropsMap {
    [ModalType.AddPagesToDocument]: AddPagesToDocumentModalData;
    [ModalType.Administrations]: AdministrationsModalData;
    [ModalType.Annotation]: AnnotationModalData;
    [ModalType.CodePreview]: CodePreviewModalData;
    [ModalType.CodingAccruals]: CodingAccrualsModalData;
    [ModalType.Confirm]: ConfirmModalData;
    [ModalType.CopyCoding]: CopyCodingModalData;
    [ModalType.CreditorValidation]: CreditorValidationModalData;
    [ModalType.DeleteOcrTraining]: DeleteOcrTrainingModalData;
    [ModalType.DocumentAttachments]: DocumentAttachmentsModalData;
    [ModalType.DocumentAudit]: DocumentAuditModalData;
    [ModalType.DocumentPreview]: DocumentPreviewModalData;
    [ModalType.DocumentValidation]: DocumentValidationModalData;
    [ModalType.DynamicAssign]: DynamicAssignModalData;
    [ModalType.EditDocument]: EditDocumentModalData;
    [ModalType.EmailDocument]: EmailDocumentModalData;
    [ModalType.EmailPreview]: EmailPreviewModalData;
    [ModalType.GridSettings]: GridSettingsModalData;
    [ModalType.LinkDocuments]: LinkDocumentsModalData;
    [ModalType.List]: ListModalData;
    [ModalType.OcrCodingTraining]: OcrCodingTrainingModalData;
    [ModalType.OcrTrainingField]: OcrTrainingFieldModalData;
    [ModalType.OcrTrainingLog]: OcrTrainingLogModalData;
    [ModalType.OcrTrainingSql]: OcrTrainingSqlModalData;
    [ModalType.PerformDocumentAction]: PerformDocumentActionModalData;
    [ModalType.RefreshLookup]: RefreshLookupModalData;
    [ModalType.RepairDocument]: RepairDocumentModalData;
    [ModalType.Replacement]: ReplacementModalData | undefined;
    [ModalType.SamBackOfficeStatusHelper]: SamBackOfficeStatusHelperModalData;
    [ModalType.SamFeedback]: object;
    [ModalType.SamLineSource]: SamLineSourceModalData;
    [ModalType.SamLineSourceMore]: object;
    [ModalType.SamIntroduction]: object;
    [ModalType.TemplateSharingManagement]: TemplateSharingManagementModalData;
    [ModalType.Text]: TextModalData;
    [ModalType.UserReplaced]: UserReplacedModalData;
    [ModalType.WorkflowActionValidation]: WorkflowActionValidationModalData;
}

type EventHandlers<T extends ModalType = ModalType> = {
    onOpen?: (modalData: ModalPropsMap[T]) => void;
    onClose?: (modalData: ModalPropsMap[T]) => void;
};

export type ModalEventHandlers = {
    [T in ModalType]?: EventHandlers<T>;
};

type ModalBaseProps<T extends ModalType = ModalType> = {
    id: string;
    isHidden?: boolean;
    size: Sizes;
    title?: string;
    subTitle?: string;
    className?: string;
    isLoading?: boolean;
    onClose?: () => void;
    externalModalName?: ExternalModalName;
    closeModal: () => void;
    updateModal: (update: Partial<Omit<Modal<T>, 'id' | 'type' | 'closeModal' | 'updateModal'>>) => void;
};

export type Modal<T extends ModalType = ModalType> = ModalBaseProps & {
    type: T;
    modalData: ModalPropsMap[T];
};
